module.exports = __webpack_public_path__ + "img/arrow-down.2200fa24.svg";